import { Box, Collapse, VStack, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import useNavItems, { isGroupItem } from 'lib/hooks/useNavItems';
import useIsAuth from 'ui/snippets/auth/useIsAuth';

import NavLink from '../vertical/NavLink';
import NavLinkRewards from '../vertical/NavLinkRewards';
import NavLinkGroup from './NavLinkGroup';

interface Props {
  onNavLinkClick?: () => void;
  isMarketplaceAppPage?: boolean;
}

const submenuListStyles = {
  listStyle: 'none',
  listStyleType: 'none' as const,
  pl: 0,
  m: 0,
};

const NavigationMobile = ({ onNavLinkClick, isMarketplaceAppPage }: Props) => {
  const { mainNavItems, accountNavItems } = useNavItems();
  const [ openedGroupIndex, setOpenedGroupIndex ] = React.useState(-1);
  const isAuth = useIsAuth();
  const isCollapsed = isMarketplaceAppPage ? false : undefined;
  const submenuColor = useColorModeValue('blackAlpha.900', 'whiteAlpha.900');

  const onGroupItemToggle = (index: number) => () => {
    setOpenedGroupIndex((prev) => (prev === index ? -1 : index));
  };

  return (
    <Box as="nav" mt={ 6 } flexGrow={ 1 }>
      <VStack
        w="100%"
        as="ul"
        spacing="0"
        alignItems="stretch"
        listStyleType="none"
        pl={ 0 }
        pr={ 0 }
      >
        { mainNavItems.map((item, index) => {
          if (isGroupItem(item)) {
            const isExpanded = openedGroupIndex === index;
            return (
              <Box as="li" key={ item.text } w="100%" px={ 2 }>
                <NavLinkGroup
                  item={ item }
                  onClick={ onGroupItemToggle(index) }
                  isExpanded={ isMarketplaceAppPage || isExpanded }
                  hideIcon
                />
                <Collapse in={ isExpanded } animateOpacity>
                  <Box
                    // pl={ 4 }
                    px={ 2 }
                    border="1px solid"
                    borderColor="divider"
                    // ml={ 2 }
                    borderRadius="base"
                    // bg="card_bg"
                    fontWeight="500"
                    fontSize="15px"
                    color={ submenuColor }
                    sx={{
                      '& ul': submenuListStyles,
                      '& li': submenuListStyles,
                      '& a': { color: 'inherit', fontSize: 'inherit', _hover: { color: 'link_hovered' } },
                    }}
                  >
                    <VStack as="ul" spacing={ 1 } alignItems="flex-start" w="100%" { ...submenuListStyles }>
                      { item.subItems?.map(
                        (subItem, subIndex) => Array.isArray(subItem) ? (
                          <Box key={ subIndex } w="100%" as="ul" mb={ 2 } { ...submenuListStyles }>
                            { subItem.map((sub) => (
                              <Box as="li" key={ sub.text } mb={ 1 } { ...submenuListStyles }>
                                <NavLink item={ sub } onClick={ onNavLinkClick } isCollapsed={ isCollapsed } isSubmenu/>
                              </Box>
                            )) }
                          </Box>
                        ) : (
                          <Box as="li" key={ subItem.text } w="100%" mb={ 1 } { ...submenuListStyles }>
                            <NavLink item={ subItem } onClick={ onNavLinkClick } isCollapsed={ isCollapsed } isSubmenu/>
                          </Box>
                        ),
                      ) }
                    </VStack>
                  </Box>
                </Collapse>
              </Box>
            );
          }
          return (
            <Box as="li" key={ item.text } w="100%" px={ 2 }>
              <NavLink item={ item } onClick={ onNavLinkClick } isCollapsed={ isCollapsed } noHorizontalPadding isFirstLevel/>
            </Box>
          );
        }) }
      </VStack>
      { isAuth && (
        <Box as="nav" mt={ 3 } pt={ 3 } borderTopWidth="1px" borderColor="divider">
          <VStack as="ul" spacing="1" alignItems="flex-start">
            <NavLinkRewards onClick={ onNavLinkClick } isCollapsed={ isCollapsed }/>
            { accountNavItems.map((item) => (
              <Box as="li" key={ item.text }>
                <NavLink item={ item } onClick={ onNavLinkClick } isCollapsed={ isCollapsed }/>
              </Box>
            )) }
          </VStack>
        </Box>
      ) }
    </Box>
  );
};

export default NavigationMobile;
